// extracted by mini-css-extract-plugin
export default {"boardTable":"Board_boardTable__lvt50"};